<template>

  <div class="web-root">

    <div class="page-container">

      <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${barHeight}px`">

        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">

          <template #left>

            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />

          </template>

        </van-nav-bar>

      </div>

      <iframe

        v-if="packageName && homePageSrc"

        id="offical-web-iframe"

        :src="homePageSrc"

        frameborder="0"

        @load="handleLoaded"

      />

    </div>

  </div>

</template>



<script>

import { buildPageSrc, getPageHost } from '@/utils/page-host.js'



export default {

  computed: {

    homePageSrc() {

      if (!this.packageName) return ''

      if (this.packageName === 'vava') {

        return buildPageSrc('vava', '/index.html')

      }

      return buildPageSrc(this.packageName, `/official_site/${this.packageName}/index.html`)

    },

    vavaPageOrigin() {

      const host = getPageHost('vava')

      return host ? `https://${host}` : ''

    },

  },

  mounted() {

    this._handleIframeMsg = (e) => {

      if (this.vavaPageOrigin && e.origin !== this.vavaPageOrigin) return

      if (e.data && e.data.type === 'VAVA_START_CHAT') {

        window.location.replace(e.data.url || this.vavaPageOrigin)

      }

    }

    window.addEventListener('message', this._handleIframeMsg)

  },

  beforeDestroy() {

    window.removeEventListener('message', this._handleIframeMsg)

  },

  methods: {

    handleLoaded() {

      try {

        // 设置facebook-domain-verification

        const iframeEle = document.getElementById('offical-web-iframe')

        if (iframeEle && iframeEle.contentWindow) {

          const metaTag = iframeEle.contentWindow.document.querySelector('meta[name="facebook-domain-verification"]')

          if (metaTag) {

            const verificationCode = metaTag.getAttribute('content')

            const meta = document.createElement('meta')

            meta.name = 'facebook-domain-verification'

            meta.content = verificationCode

            document.head.appendChild(meta)

          }

        }

      } catch (error) {

        console.log('try catch error:', error)

      }

    },

  },

}

</script>



<style lang="scss" scoped>

.web-root {

  width: 100%;

  height: 100vh;

  overflow-y: hidden;

  display: flex;

  flex-direction: column;

  .page-container {

    box-sizing: border-box;

    background-color: #000000;

    padding: 0;

    flex: 1;

    display: flex;

    flex-direction: column;

    .mobile-bar {

      width: 100%;

    }

    #offical-web-iframe {

      flex: 1;

      width: 100%;

    }

  }

}

</style>


